export default "/static/assets/favicon.fe9352f3eae9c720d177c4f7b2e0a58b.png";